<div class="min-h-screen bg-white font-inter text-slate-950">
  <div class="flex min-h-screen flex-col items-center justify-center gap-8 px-6 py-12 text-center">
    <img
      src="assets/brand/logo.svg"
      width="48"
      height="48"
      alt="FormOps logo"
      class="h-12 w-12 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/10" />

    <div class="flex flex-col items-center gap-3">
      <h1 class="text-h5 font-semibold text-slate-950">Sign-in failed</h1>
      <p class="max-w-md text-body1 text-slate-600">{{ message() }}</p>
    </div>

    <div class="flex flex-wrap items-center justify-center gap-4">
      @if (isAccountNotFound()) {
        <a routerLink="/signup" class="inline-flex rounded-xl bg-primary-600 px-5 py-3 text-body2 font-medium text-white transition hover:bg-primary-700">
          Create account
        </a>
        <a routerLink="/login" class="text-body2 font-medium text-primary-600 hover:text-primary-700">
          Back to sign in
        </a>
      } @else {
        <a routerLink="/login" class="text-body2 font-medium text-primary-600 hover:text-primary-700">
          Back to sign in
        </a>
        <a routerLink="/signup" class="text-body2 font-medium text-primary-600 hover:text-primary-700">
          Create account
        </a>
      }
    </div>
  </div>
</div>
